export enum AribaSyncType {
  INBOUND = 'to_evisort',
  OUTBOUND = 'from_evisort',
  BIDIRECTIONAL = 'bidirectional',
}
